import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import fr from './fr.json'

/**
 * Français uniquement en V1 (ADR-015). Toute chaîne visible passe par t() :
 * ajouter une langue = ajouter un fichier JSON, sans toucher aux écrans.
 */
void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr } },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
